module.exports = __webpack_public_path__ + "img/hot.1e11cf08.svg";